import { createContextManager, storeContextManager } from '@datadog/browser-core';
export function startGlobalContext(configuration) {
    const globalContextManager = buildGlobalContextManager();
    if (configuration.storeContextsAcrossPages) {
        storeContextManager(configuration, globalContextManager, 'rum', 2 /* CustomerDataType.GlobalContext */);
    }
    return globalContextManager;
}
export function buildGlobalContextManager() {
    return createContextManager('global context');
}
//# sourceMappingURL=globalContext.js.map